import React from 'react';

import ShipmentModalAssignment from 'components/ShipmentModalAssignment';

const Assignment = ({ item, openBaseModal, onClose, assign }) => {
  const handleAssignment = (data) => {
    return new Promise(() => {
      assign(data);
    });
  };

  return (
    item && (
      <ShipmentModalAssignment
        show={true}
        onTop
        journey={item}
        route={item && item.route}
        driver={item.driver}
        vehicle={item.vehicle}
        trailer={(item.vehicles || []).find((v) => v.vehicle_type === 'trailer')}
        onAssign={handleAssignment}
        onClose={onClose || openBaseModal}
      />
    )
  );
};

export default Assignment;
